import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DisputeDetailsComponent } from './dispute/dispute-details/dispute-details.component';
import { HomeComponent } from './home/home.component';
import { InvoicesComponent } from './invoices/invoices.component';
import { BQUsageRecordComponent } from './bq-usage-record/bq-usage-record.component';
import { BillAnalystComponent } from './bill-analyst/bill-analyst.component';
import { PaymentHistoryComponent } from './payment-history/payment-history.component';
import { HistoricalDataComponent } from './historical-data/historical-data.component';
import { PaperlessBillingComponent } from './setting/paperless-billing/paperless-billing.component';

const routes: Routes = [
  { path: '', component: HomeComponent, pathMatch: 'full' },
  { path: 'invoices', component: InvoicesComponent, pathMatch: 'full' },
  { path: 'payment-history', component: PaymentHistoryComponent },
  { path: 'paperless-billing', component: PaperlessBillingComponent},
  { path: 'historical-data', component: HistoricalDataComponent },
  { path: 'dispute-details', component: DisputeDetailsComponent },
  { path: 'usage-record', component: BQUsageRecordComponent },
  { path: 'bill-analyst', component: BillAnalystComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
